import React, {createContext, useMemo, useReducer} from 'react';
import Layout from '../Shared/Layout';
import {Container} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import BackButton from "../Shared/BackButton";
import {DynamicColorPreset} from "../Shared/DynamicColorPreset";
import { Trans } from "../utils/i18n";
import {appointment} from "../config/appointment";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import {FormState, FormStateDispatch} from "../FormComponents/FormState";
import {Button} from "@mui/material";
import {InertiaLink} from "@inertiajs/inertia-react";


const SuccessPage = function ({ response }) {
    return (<div>
        <h2>
            <Trans i18nKey="appointment.form.success">Thank you for your request!</Trans>
        </h2>
        <p>
            <Trans i18nKey="appointment.form.success.description">We will confirm your appointment in a couple of minutes via E-Mail. If you want to cancel the appointment, please use the Cancel-Button in the E-Mail and request a new appointment.</Trans>
        </p>
        <Button variant={'contained'} color={'primary'} href={route('appointment')} component={InertiaLink}>
            <Trans i18nKey="appointment.makeAnotherAppointment">Make another appointment</Trans>
        </Button>
    </div>);
}

export default function OrderEntry({  products }) {
    return (
        <FormState>
            <div>
                <Container maxWidth="md">
                    <h1><Trans i18nKey="appointment.form.label">Request Appointment</Trans></h1>
                    <Trans getRaw i18nKey="appointment.form.label.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>
                    <FormPage
                        orderEntryConfig={appointment}
                        endpointUrl={route('appointment.create')}
                        SuccessPage={SuccessPage}
                    />
                </Container>
            </div>
        </FormState>
    )
}


OrderEntry.layout = page => <Layout children={page} />;
